<template>
    <div
      class="h-full flex flex-col items-center justify-center cursor-pointer odd w-full"
      :class="[
        favLayout && 'favLClass',
        isHighlited(odd.i) && favLayout && 'favLayActive',
        isHighlited(odd.i) ? 'bg-[var(--color-grey9)]' : 'hover:bg-[var(--color-white15)]'
      ]"
      @click="betslip.setOdd(odd, event.i, mi, mnrs)"
      v-if="odd  && odd.st != 2"
    >
      <p
        class="text-[13px]"
        :class="[
          favLayout ? 'w-full flex items-center justify-between px-2' : '',
          odd.st == 3 && 'text-neutral-400 flex items-center justify-between',
          (odd.st == 0 || odd.st == 1) && 'text-[var(--color-yellow1)]',
          isHighlited(odd.i) && '!text-[var(--color-primary1)]'
        ]"
      >
        <span
          v-if="withName"
          class="mr-2"
          :class="[
            favLayout ? ' whitespace-nowrap' : '',
            (odd.st == 1 || odd.st == 0) ? 'text-white whitespace-nowrap' : '',
          ]"
        >
          {{ name }} 
        </span>
  
        <img
          v-if="odd.st == 3"
          src="/lock2.svg"
          class="h-4 w-4 mb-1"
          alt="Locked"
        />
  
        <span
          v-else 
          class="text-[13px]"
          :class="[oddClasses, hasChanged ? 'font-bold' : '', favLayout ? '' : '']"
        >
          {{ getOddType == 'p' ? toFixedTwo(odd[getOddType]) : odd[getOddType] }}
        </span>
      </p>
    </div>
  </template>
  
  <script setup>
  import { toFixedTwo, safeTranslate } from '@/helpers';
  import { useBetslipStore } from '@/stores/betslip';
  import { storeToRefs } from 'pinia';
  import { computed, ref, watch } from 'vue';
  import { useI18n } from 'vue-i18n';
  
  const { t, te } = useI18n();
  const props = defineProps({
    odd: Object,
    oddClasses: String,
    mi:Number,
    event:Object,
    favLayout: { type: Boolean, default: false },
    withName: { type: Boolean, default: false },
    mnrs:Array
  });
  
  const betslip = useBetslipStore();
  const { isHighlited, getOddType } = storeToRefs(betslip);
  const hasChanged = ref(false);

const name = computed(() => safeTranslate('selections', props.odd.n, t, te))
  
  watch(
    () => props.odd,
    (val) => {
      if (val) {
        hasChanged.value = true;
        setTimeout(() => (hasChanged.value = false), 1000);
      }
    },
    { deep: true }
  );
  </script>
  
  <style scoped>
  .favLClass {
    @apply bg-neutral-900 text-yellow-400 flex justify-between w-full;
  }
  .favLayActive {
    @apply ring-2 ring-[var(--color-primary1)] bg-[var(--color-grey9)];
  }
  </style>
  